import Vuex from "vuex";
import Vue from "vue";
import { functions } from "@/utils/functions";

Vue.use(Vuex);

export const consultations = {
  namespaced: true,
  state: () => ({
    consultations: null,
    consultation: null,
  }),
  getters: {},
  mutations: {
    SET_CONSULTATIONS(state, consultations) {
      state.consultations = consultations;
    },
    SET_CONSULTATION(state, consultation) {
      state.consultation = consultation;
    },
  },
  actions: {
    // INDEX METHODS
    fetchConsultations: function ({ commit }, queryParams = {}) {
      this.$store.dispatch("loading/triggerTableLoader");
      const url = `doctors/consultations`;
      const query = functions.query(url, queryParams);

      return this.$axios
        .get(query)
        .then((response) => {
          commit("SET_CONSULTATIONS", response.data);
        })
        .catch((error) => {
          console.error("Error Fetching Consultations For Doctor: ", error);
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerTableLoader");
        });
    },

    // SHOW METHODS
    // show the consultation details for the doctor based on their specialization
    showConsultationForDoctor: function ({ commit }, consultation_id) {
      const url = `doctors/consultations/${consultation_id}`;
      return this.$axios
        .get(url)
        .then((response) => {
          commit("SET_CONSULTATION", response.data.consultation);
        })
        .catch((error) => {
          console.error("Error Fetching Consultation For Doctor: ", error);
        });
    },
    //show the consultation details for all of the 
    showConsultation: function ({ commit }, consultation_id) {
      const url = `admin/consultations/${consultation_id}`;
      return this.$axios
        .get(url)
        .then((response) => {
          commit("SET_CONSULTATION", response.data.consultation);
        })
        .catch((error) => {
          console.error("Error Fetching Consultation For Admin: ", error);
        });
    },

    // PATCH METHODS
    toggleServiceProgress(
      { dispatch },
      { hospital_service_id, consultation_id, status, role }
    ) {
      this.$store.dispatch("loading/triggerFunctionLoader", "submit");
      const url = `hospital-services/${hospital_service_id}/toggle-status`;
      const whichDispatch =
        role === "ROOT"
          ? "showConsultation"
          : "showConsultationForDoctor";

      return this.$axios
        .patch(url, status)
        .then((response) => {
          this.$store.commit("alerts/SET_SHOW_ALERT", response.data.message);
          dispatch(whichDispatch, consultation_id);
        })
        .catch((error) => {
          console.error("Error Patching Status: ", error);
          this.$store.commit(
            "alerts/SET_SHOW_ERROR",
            error.response.data.message
          );
        })
        .finally(() => {
          this.$store.dispatch("loading/detriggerFunctionLoader", "submit");
        });
    },
    resetConsultations({ commit }) {
      commit("SET_CONSULTATIONS", null);
    },
    resetConsultation({ commit }) {
      commit("SET_CONSULTATION", null);
    },
  },
};
